import { render, staticRenderFns } from "./SizeCard.vue?vue&type=template&id=1b3305ca&"
import script from "./SizeCard.vue?vue&type=script&lang=js&"
export * from "./SizeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports